import { Component, Element, h, State } from '@stencil/core';
import { I18nUtil } from '../../../utils/i18n/I18nUtil';
import { Collapse } from 'bootstrap';

/**
 * @internal
 */
@Component({
  tag: 'bahf-cd-collapse',
  styleUrl: 'bahf-cd-collapse.scss',
  scoped: false,
})
export class BahfCdCollapse {
  readonly COLLAPSE_ID = 'bahf-cd-collapse';
  @State() collapsed: boolean;
  @Element() el: HTMLElement;

  collapseRef: HTMLElement;

  bsCollapse: Collapse;

  constructor() {
    this.collapsed = true;
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.collapsed = !this.collapsed;
    event.preventDefault();
  }

  componentDidRender() {
    /* istanbul ignore if */
    if (window.dpl?.bs) {
      this.bsCollapse = new window.dpl.bs.Collapse(this.collapseRef, { toggle: false });
    }
  }

  render() {
    return (
      <div class="panel ba-hf-cd-collapse-dpl3">
        <div class="panel-heading">
          <div class="panel-title">
            <a
              aria-controls={this.COLLAPSE_ID}
              aria-expanded={this.collapsed ? 'false' : 'true'}
              aria-label={
                this.collapsed
                  ? I18nUtil.getTranslation('OffenerAriaLabel')
                  : I18nUtil.getTranslation('GeschlossenerAriaLabel')
              }
              class={`ba-hf-cd-collapse-dpl3__toggle collapsed ${
                this.collapsed ? 'ba-link-down' : 'ba-link-up'
              }`}
              data-testid="bahf-cookie-disclaimer-btn-collapse"
              onClick={this.handleClick}
              role="button"
              href="#"
            >
              {this.collapsed
                ? I18nUtil.getTranslation("GeschlossenerText")
                : I18nUtil.getTranslation("OffenerText")}
            </a>
          </div>
        </div>
        <div
          aria-labelledby={this.COLLAPSE_ID}
          class={`panel-collapse collapse ${this.collapsed ? '' : 'show'}`}
          id={this.COLLAPSE_ID}
          role="tabpanel"
          ref={(el) => {
            this.collapseRef = el;
          }}
        >
          <div class="panel-body">
            <slot></slot>
          </div>
        </div>
      </div>
    );
  }
}
